export default "__VITE_ASSET__41b8a70e__"